import { Card, CardBody, CardHeader } from "reactstrap";

const AssessmentSection = ({
    id,
    title,
    subtitle,
    headerActions,
    children
}) => {
    return (
        <section
            id={id}
            className="ai-act-questionnaire-panel"
        >
            <Card className="ai-act-questionnaire-panel__card mb-0">
                <CardHeader className="ai-act-questionnaire-panel__header">
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
                        <div>
                            <h5 className="mb-1 fw-semibold">
                                {title}
                            </h5>

                            {subtitle && (
                                <p className="text-muted mb-0 small">
                                    {subtitle}
                                </p>
                            )}
                        </div>

                        {headerActions && (
                            <div className="d-flex align-items-center flex-wrap gap-2">
                                {headerActions}
                            </div>
                        )}
                    </div>
                </CardHeader>

                <CardBody className="ai-act-questionnaire-panel__body">
                    {children}
                </CardBody>
            </Card>
        </section>
    );
};

export default AssessmentSection;
